/**
 * QuickFormHeader
 * 업무 제목 + 난이도 입력 영역.
 *
 * PC      : 제목/난이도를 각각 inline 박스(테두리)로, 가로로 배치
 * Mobile  : 풀폭 세로 스택, 터치 타깃 크게 (한 손 입력 우선)
 */
export default function QuickFormHeader({
  title,
  difficulty,
  onChangeTitle,
  onChangeDifficulty,
  isMobile,
}) {
  const labelStyle = {
    fontSize: 13,
    fontWeight: 600,
    color: "#0f172a",
    whiteSpace: "nowrap",
    flexShrink: 0,
  };

  // ───────── 모바일 ─────────
  if (isMobile) {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 12 }}>
        {/* 제목 */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 6,
            border: "0.5px solid #cbd5e1",
            borderRadius: 10,
            padding: "3px 12px",
            background: "#f8fafc",
          }}
        >
          <span style={labelStyle}>제목</span>
          <input
            type="text"
            value={title}
            onChange={(e) => onChangeTitle(e.target.value)}
            placeholder="업무 제목 *"
            style={{
              width: "100%",
              boxSizing: "border-box",
              border: "0.5px solid #e2e8f0",
              borderRadius: 8,
              padding: "10px 12px",
              fontSize: 16, // iOS 자동 줌 방지 (16px 이상)
              outline: "none",
              background: "#fff",
              color: "#0f172a",
            }}
          />
        </div>

        {/* 난이도 */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            border: "0.5px solid #cbd5e1",
            borderRadius: 10,
            padding: "3px 12px",
            background: "#f8fafc",
          }}
        >
          <span style={labelStyle}>난이도</span>
          <input
            type="number"
            inputMode="numeric"
            min="1"
            max="10"
            value={difficulty}
            onChange={(e) => onChangeDifficulty(e.target.value)}
            style={{
              width: 72,
              boxSizing: "border-box",
              border: "0.5px solid #e2e8f0",
              borderRadius: 8,
              padding: "10px 8px",
              fontSize: 16,
              outline: "none",
              background: "#fff",
              color: "#0f172a",
              textAlign: "center",
            }}
          />
          <span style={{ fontSize: 13, color: "#64748b", whiteSpace: "nowrap" }}>/ 10 점</span>
        </div>
      </div>
    );
  }

  // ───────── PC ─────────
  return (
    <>
      {/* 제목 */}
      <div
        style={{
          marginTop: 6,
          marginBottom: 8,
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          border: "0.5px solid #cbd5e1",
          borderRadius: 8,
          padding: "8px 12px",
          background: "#f8fafc",
        }}
      >
        <span style={labelStyle}>제목</span>
        <input
          type="text"
          value={title}
          onChange={(e) => onChangeTitle(e.target.value)}
          placeholder="업무 제목 *"
          style={{
            width: 360,
            boxSizing: "border-box",
            border: "0.5px solid #e2e8f0",
            borderRadius: 6,
            padding: "6px 10px",
            fontSize: 14,
            outline: "none",
            background: "#fff",
            color: "#0f172a",
            marginTop: 8,   // 입력창만 살짝 아래로


          }}
        />
      </div>

      {/* 난이도 */}
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          marginBottom: 10,
          border: "0.5px solid #cbd5e1",
          borderRadius: 8,
          padding: "8px 12px",
          background: "#f8fafc",
          
        }}
      >
        <span style={labelStyle}>난이도</span>
        <input
          type="number"
          min="1"
          max="10"
          value={difficulty}
          onChange={(e) => onChangeDifficulty(e.target.value)}
          style={{
            width: 64,
            boxSizing: "border-box",
            border: "0.5px solid #e2e8f0",
            borderRadius: 6,
            padding: "6px 10px",
            fontSize: 14,
            outline: "none",
            background: "#fff",
            color: "#0f172a",
            textAlign: "center",
            marginTop: 8,   // 입력창만 살짝 아래로


          }}
        />
        <span style={{ fontSize: 13, color: "#64748b", whiteSpace: "nowrap" }}>/ 10 점</span>
      </div>
    </>
  );
}